import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { getAlbumDateLabel } from '../../../../../util/album';
import CustomControl from '../../../../../components/global/CustomControl';

const propTypes = {
  photoGroup: PropTypes.shape({
    id: PropTypes.string,
  }),
  onPhotoGroupClick: PropTypes.func.isRequired,
  selectedTargets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
};

const PhotoGroupSelectionRow = ({
  photoGroup,
  selectedTargets,
  onPhotoGroupClick,
}) => {
  return (
    <Fragment>
      <tr
        key={propTypes.id}
        onClick={event => {
          event.preventDefault();
          onPhotoGroupClick(photoGroup);
        }}
      >
        <td className="text-left d-flex align-items-center ml-3">
          <CustomControl
            id={photoGroup.id}
            type="checkbox"
            checked={
              !!selectedTargets.find(
                target => target.photoGroup?.id === photoGroup.id,
              )
            }
            readOnly
            label={photoGroup.name}
            size="sm"
          />
        </td>
        <td className="text-left">&ndash;</td>
        <td className="text-left" colSpan={2}>
          {getAlbumDateLabel(photoGroup)}
        </td>
      </tr>
    </Fragment>
  );
};

PhotoGroupSelectionRow.propTypes = propTypes;

export default PhotoGroupSelectionRow;
